import React, { useCallback, useState } from 'react';
import { ModalContent, ModalMain, Bottom, List, Figure, Datetime } from './styles';
import { formatDate, isEmpty } from '../../../helpers/common';
import { ScreenshotListInterface } from '../../../interfaces/TimeReportInterface';
import { useHotkeys } from 'react-hotkeys-hook';
import IconButton from '../../button/iconButton';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';
import ModalHeader from '../modalHeader';
import Image from '../../image';
interface UserData {
  taskName?: string;
  time?: string;
  mouseClicks?: string;
  mainImage: ScreenshotListInterface[];
  keyBoardHits?: string;
  modalClose?: () => void;
}

const ScreenShotModal: React.FC<UserData> = (props) => {
  //States
  const [image, setImage] = useState<ScreenshotListInterface>(props.mainImage[0]);
  const [index, setIndex] = useState(0);

  const onClickImage = useCallback((item: ScreenshotListInterface, index: number) => {
    setImage(item);
    setIndex(index);
  }, []);

  const onClickPreviousImage = useCallback(() => {
    if (props?.mainImage?.length > 1) {
      const newIndex = index > 0 ? index - 1 : props?.mainImage.length - 1;
      setIndex(newIndex);
      setImage(props?.mainImage[newIndex]);
    }
  }, [index, props?.mainImage]);

  const onClickNextImage = useCallback(() => {
    if (props?.mainImage?.length > 1) {
      const newIndex = index < props?.mainImage.length - 1 ? index + 1 : 0;
      setIndex(newIndex);
      setImage(props?.mainImage[newIndex]);
    }
  }, [index, props?.mainImage]);

  useHotkeys('ArrowLeft', async (event) => {
    event.preventDefault();
    onClickPreviousImage();
  });

  useHotkeys('ArrowRight', async (event) => {
    event.preventDefault();
    onClickNextImage();
  });

  return (
    <ModalMain>
      <ModalHeader title={props.taskName} description={props.time} onClose={props.modalClose} />
      <ModalContent>
        <IconButton
          iconName='new-large-back-arrow-icon'
          size={ICON_BUTTON_SIZE.SMALL}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={onClickPreviousImage}
        />
        <Image
          src={!isEmpty(image) ? image?.Url : props.mainImage[0]?.Url}
          width={576}
          height={324}
          alt='screenShotImage'
        />
        <Datetime>
          <p>{formatDate(image?.CreatedTime).time}</p> <p>{formatDate(image?.CreatedTime).formattedDate}</p>
        </Datetime>
        <IconButton
          iconName='updated-large-right-arrow-icon'
          size={ICON_BUTTON_SIZE.SMALL}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={onClickNextImage}
        />
      </ModalContent>
      <Bottom>
        <List>
          {props.mainImage?.map((item, index: number) => {
            return (
              <Figure
                role='button'
                key={item?.Url}
                isActive={image?.Url === item?.Url}
                onClick={() => onClickImage(item, index)}>
                <Image src={item?.Url} width={80} height={44} alt='screenShotImage' />
              </Figure>
            );
          })}
        </List>
      </Bottom>
    </ModalMain>
  );
};

export default ScreenShotModal;
